import React from 'react';

import isEmpty from 'lodash/isEmpty';
import map from 'lodash/map';

import SiteViewerVersionComponentSelector
  from 'zoomforth_codesbane_viewer/component_lib/site_viewer_version_component_selector_container.jsx';

import { getUrl, getTarget } from 'zoomforth_codesbane_viewer/lib/app_actions.js';


const SubmenuDropdownUi_ViewerVersion1 = ({ menuItems, onDropdownSubmenuItemClick })=> (
  <div className="nav-link-subsection-dropdown-wrapper">
    
    <div className="nav-link-subsection-dropdown-spacer">
      <div className="nav-link-dropdown-up-arrow"></div>
    </div>
    
    <div className="nav-link-subsection-dropdown">
      {
        map(menuItems, (menuItem)=> (
          <div
            key={menuItem.id}
            className="dropdown-nav-link-wrapper"
          >
            <a 
              href={getUrl(menuItem.appAction)} 
              target={getTarget(menuItem.appAction)}
              className="action-nav-link dropdown-nav-link"
              onClick={()=> {
                onDropdownSubmenuItemClick(menuItem);
              }}
            >
              <span className="dropdown-nav-link-inner">
                {menuItem.title}
              </span>
            </a>
          </div>
        ))
      }
    </div>
    
  </div>
);

const SubmenuDropdownUi_ViewerVersion2 = ({ menuItems, onDropdownSubmenuItemClick })=> (
  <div className="nav-link-subsection-dropdown-wrapper">
    
    <div className="nav-link-subsection-dropdown-spacer">
      <div className="nav-link-dropdown-up-arrow"></div>
    </div>
    
    <ul className="nav-link-subsection-dropdown" role="list">
      {
        map(menuItems, (menuItem)=> (
          <li
            key={menuItem.id}
            className="dropdown-nav-link-wrapper"
          >
            <a 
              href={getUrl(menuItem.appAction)} 
              target={getTarget(menuItem.appAction)}
              className="action-nav-link dropdown-nav-link"
              onClick={()=> {
                onDropdownSubmenuItemClick(menuItem);
              }}
            >
              <span className="dropdown-nav-link-inner">
                {menuItem.title}
              </span>
            </a>
          </li>
        ))
      }
    </ul>
    
  </div>
);

const SubmenuDropdownUiComponent = (props)=> (
  <SiteViewerVersionComponentSelector>
    <SubmenuDropdownUi_ViewerVersion1 forSiteViewerVersion={1} { ...props } />
    <SubmenuDropdownUi_ViewerVersion2 forSiteViewerVersion={2} { ...props } />
  </SiteViewerVersionComponentSelector>
);

const SubmenuDropdownUi = ({ menuItems, onDropdownSubmenuItemClick })=> {
  if (isEmpty(menuItems)) {
    return null;
  }

  return (
    <SubmenuDropdownUiComponent
      menuItems={menuItems}
      onDropdownSubmenuItemClick={onDropdownSubmenuItemClick}
    />
  );
};

export default SubmenuDropdownUi;
